import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="text-center bold mb-3 mt-3">* * *</p>

    <p class="mb-3">
      Li mortis nokte. 
      Subite haltis la pulsado de la koro, oksigeno ne plu pasadis tra la cerbo, kaj mallumo ĉirkaŭvolvis lin.
    </p>
    
    <p class="mb-3">
      Aŭ li mortis tage, dum matenmanĝo. 
      Jam delonge lezita, stomako ne plu eltenis, kaj pro ĝia ŝiro la sango inundis interne de la korpo.
    </p>
    
    <p class="mb-3">
      Aŭ li mortis en koridoro, elirante el unu ĉambro al la alia, kie lin atendis komputilo kun neresponditaj leteroj. 
      Arterio en la cerbo krevis, kaj la sango inundis la kapon.
    </p>
    
    <p class="mb-3">
      Neniu scias, kiel li mortis. 
      Post du semajnoj la maltrankviligitaj najbaroj vokis la policon, kaj tiuj, frakasinte la pordon, enimpetis en la loĝejon… kaj ekvidis la kadavron.
    </p>
    
    <p class="mb-3">
      Li loĝis sola. Jam delonge… jes, ĉiam li loĝis sola. 
      Li amis, certe, li amis; sed tiu ŝi ne amis lin. 
      Li suferis, kiel suferas ajna junulo en tia stato; sed poste la situacio tute renversiĝis, kaj alia ŝi ekamis lin. 
      Kaj tiam li komprenis, kiom ege pli malagrable kaj dolore estas suferi pro neamo, kiam oni estas pasiva objekto de ies sento, kaj tiu pasiveco poiomete konvertiĝas en abomenon.
    </p>
    
    <p class="mb-3">
      Do, li estis amanta kaj amata… sinsekve, ne sametempe. 
      Kaj li estis sola, ĝis la fino de sia sufiĉe longa vivo. 
      Sed ĉu vere li estis sola?
    </p>
    
    <p class="mb-3">
      Dum la tuta sia konscia vivo li estis ĉirkaŭita de infanoj kaj gejunuloj. 
      Li gvidis junularan klubon kaj ĉiam strebis doni pli multe el siaj scioj al «gejunuloj kun saĝaj okuloj». 
      Kaj gejunuloj kun saĝaj okuloj strebis al li. 
      En komunikado kun ili li travivis multajn vivojn, sennombrajn amojn, li ĉiufoje denove malkovradis vivajn principojn kaj filozofiajn tezojn, denove penadis kompreni la mondon tra novaj, ĵus malfermitaj okuloj.
    </p>
    
    <p class="mb-3">
      Li mortis. 
      Sed kiom da vivoj li travivis!
    </p>
    `
  )
}

const itemName = {
  esp: 'Li mortis nokte'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: `
      Memore al L. Kinoŝever, <br/>
      ${author.esp}
    `,
    itemDate: 'Junio 2015'
  }
}

export default item;